import { createContext, useContext } from 'react'

/**
 * Explicit accept/reject persistence callbacks for in-editor React surfaces
 * (node views) that decide AI proposals outside the hover-popover pipeline —
 * today only the choice node view, whose "click a different option" gesture
 * rejects the pending choice suggestion while applying the clicked value.
 *
 * The hover popover gets these callbacks as props from `CollaborativeEditor`;
 * a node view can't, so it reads them from context instead (the same bridge
 * pattern as `SuggestionRevealContext`). Provided by `CollaborativeEditor`;
 * null on bare/standalone editors, where a reject stays decoration-only with
 * nothing to persist.
 */
export interface AIProposalActions {
  /**
   * Persist an EXPLICIT clinician reject (status='rejected' via the same
   * debounced projection the hover popover's Reject uses), so a dismissed
   * suggestion can't resurrect on the next re-paint/reload.
   */
  onReject: (ids: string[]) => void
}

const AIProposalActionsContext = createContext<AIProposalActions | null>(null)

export const AIProposalActionsProvider = AIProposalActionsContext.Provider

export function useAIProposalActions(): AIProposalActions | null {
  return useContext(AIProposalActionsContext)
}
